import styled from "styled-components";

interface ITrProps {
  isFirst: boolean;
}

export const Table = styled.table.attrs({
  className: "border border-collapse w-full",
})``;

export const TR = styled.tr.attrs((props: any) => ({
  className: `w-full py-2 flex items-center px-10 ${
    props.isFirst && "rounded-t"
  }`,
}))<ITrProps>`
  // border:1px solid rgba(58, 53, 65, 0.23);
  border-top: 1px solid #dbcbe1;
  border-bottom: 1px solid #dbcbe1;
  border-right: 1px solid #dbcbe1;
  border-left: 1px solid #dbcbe1;

  td {
    flex: 1;
  }
`;
export const BtnSuccess = styled.button.attrs({
  className: "px-5 py-2 border-none bg-teal-600 rounded text-sm ",
})`
  color: white;
  cursor: pointer;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  margin-right: 5px;
  @media screen and (max-width: 580px) {
    margin: 0 10px;
  }
  @media screen and (max-width: 425px) {
    margin: 0;
  }
`;
export const BtnDanger = styled.button.attrs({
  className: "px-5 py-2 border-none rounded text-sm bg-red-500 ",
})`
  color: white;
  cursor: pointer;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// styles for approvals heading component
export const ApprovalHeading = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
export const SubApprovalHeading = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 2.25rem;
  color: #18181b;
`;
export const SubmittedBy = styled.div`
  font-size: 0.8rem;
  color: #8b6697;
`;
export const IncidentNumber = styled.div`
  color: #b580ff;
  font-size: 1.1rem;
`;
export const ApprovalSectionHeading = styled.h2`
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 700;
  color: #8b6697;
  margin: 20px 0;
  margin-top: 50px;
`;
export const Signatory = styled.td`
  font-family: "Inter";
  font-size: 0.9rem;
  line-height: 1.5rem;
  color: #8b6697;
`;
export const SignatoryStatus = styled.td`
  font-family: "Inter";
  font-size: 0.9rem;
  line-height: 1.5rem;
  color: #8b6697;
`;
export const SignedOffBy = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  /* identical to box height */
  display: flex;
  align-items: center;
  color: #482952;
  margin: 10px 0;
`;
export const Divider = styled.span`
  color: #dbcbe1;
  color: black;
  color: #482952;
  margin: 0 5px;
`;
export const SignatoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
`;
export const SignatoryCommentContainer = styled.div``;
export const SignatoryHeading = styled.h3`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 28px;
  color: #482952;
`;
export const SignatoryComment = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 28px;
  /* identical to box height, or 200% */

  /* PRIMARY/$-primary-main */

  color: #3d0052;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 1;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 16px;
  border: 1px solid #dbcbe1;
  border-radius: 5px;
`;

// styles for approvals container
export const ApprovalContainer = styled.div`
  border-radius: 4px;

  @media screen and (min-width: 581px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  border: 1px solid rgba(58, 53, 65, 0.23);
  padding: 1em;
  border-top: 1px solid #dbcbe1;
  border-bottom: 1px solid #dbcbe1;
  border-right: 1px solid #dbcbe1;
  border-left: 1px solid #dbcbe1;
`;
// styles for Approval title container
export const ApprovalTitleContainer = styled.div`
  /* border: 1px solid gold; */
  margin: 5px 0;
`;
// styles for Approval title
export const ApprovalTitle = styled.p`
  font-family: "Inter";
  font-size: 0.9rem;
  line-height: 1.5rem;
  color: #8b6697;
`;
// styles for Approval Status Container
export const ApprovalStatusContainer = styled.div`
  @media screen and (max-width: 580px) {
    margin: 5px 0;
  }
`;
// styles for Approval Status
export const ApprovalStatus = styled.p`
  font-family: "Inter";
  font-size: 0.9rem;
  line-height: 1.5rem;
  color: #8b6697;
`;
// styles for Approval Button Container
export const ApprovalButtonContainer = styled.div`
  @media screen and (max-width: 580px) {
    display: flex;
    justify-content: flex-end;
  }
  @media screen and (max-width: 425px) {
    margin: 5px 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
`;
// styles for Approval Button
export const ApprovalButton = styled.button``;
// styles for Comment Container
export const CommentContainer = styled.div``;
// styles for signed off by container
export const SignedOffByContainer = styled.div``;
// styles for Comment
export const Comment = styled.p``;
